import settingJson from "./settings.json";

export const settings = {
  checkPermission: false,
  version: settingJson.version,
  isDev: import.meta.env.VITE_IS_DEV == "true",
};
